import React, { useState,useEffect } from 'react';
import { Dropdown } from 'react-bootstrap';
import MultiSelect from '../../src/common/MultiSelect';
import { useLanguage } from "../../src/context/LanguageContext";
import secureStorage from "@src/config/encrypt";
import * as HELPER from "../../src/config/helper";
import {OPS_ROLE_ID,MAKER_ROLE_ID,CHECKER_ROLE_ID, MANAGER_LEVEL_IDS} from '../config/constant'
import Select, { components } from 'react-select';
import {filters} from '../config/switch';
import { renderFilterField } from '../component/filter/FilterRenderer';
const { ValueContainer, Placeholder } = components;

const CustomValueContainer = (props: any) => {
  return (
    <ValueContainer {...props}>
      <Placeholder {...props} isFocused={props.isFocused}>
        {props.selectProps.placeholder}
      </Placeholder>
      {React.Children.map(props.children, (child: any) =>
        child && child.type !== Placeholder ? child : null
      )}
    </ValueContainer>
  );
};

type OptionType = {
  value: string;
  label: string;
};


const ReconcilationMoreFilter: React.FC<any> = ({ config, submitHandler, selectedFilters, setSelectedFilters,assignUsers }) => {
    const [isPopupOpen, setPopupOpen] = useState(false);
    const {translations} = useLanguage();
    const [remittance_status , setRemittanceStatus] = useState<any>({});

    /**
   * FILTER SEARCH HANDLER
   */
    const onFilterSearch = () => {
        submitHandler({ page_number: 1, ...selectedFilters });
        setPopupOpen(false);
    }

    /**
     * FILTER RESET HANDLER
     */
    const onFilterReset = () => {
        setSelectedFilters({});
        submitHandler({});
        setPopupOpen(false);
    }

    

      /**
    * HANDLE CHANGE FOR SELECTED OPTIONS
  */
  const handleChange = (selectedOption: any, key: string) => {
    let updatedFilters: any = {};
    if (selectedOption instanceof Array) {
      // For multi-select (array of options)
      updatedFilters[key] = selectedOption.map((e) => e.value);
    }else {
      // For single select
      updatedFilters[key] = selectedOption?.value || null;
    }
    setSelectedFilters((prev: any) => ({
      ...prev, // keep old filters
      ...updatedFilters, // merge new filters
    }));
  };

    const authUserInfo = secureStorage.getItem("authUserInfo");
    const filterConfig = filters.reconciliationMoreFilters(translations)
    return (
        <div className="filter-option">
            <Dropdown show={isPopupOpen} onToggle={(isOpen: any) => setPopupOpen(isOpen)}>
                <div className="text-btn d-flex">
                    <Dropdown.Toggle variant="success" id="dropdown-basic">
                        <span className="more-filter-txt">More Filters</span>
                        <span className="leass-filter-txt">Less Filters</span>
                    </Dropdown.Toggle>

                    <div className="btn-submit-reset top-btn-none">
                        <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                        <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                    </div>
                </div>

                <Dropdown.Menu>
                    <div className="more-filter-option">
                        <h3>More Filters</h3>
                        <div className="filter-form">
                            {filterConfig.map((filter:any) =>
                                renderFilterField(filter, { selectedFilters, handleChange, translations, authUserInfo, CustomValueContainer,
                                    options: { 
                                        lead_types: config?.lead_types,
                                        assigning_filters:config?.assigning_filters,
                                        assign_user_id:assignUsers
                                    }
                                })
                            )}
                            <div className="btn-submit-reset more-filter-btn">
                                <button className="btn-primary" onClick={onFilterSearch}>Search</button>
                                <button className="btn-reset" onClick={onFilterReset}>Reset</button>
                            </div>
                        </div>
                    </div>
                </Dropdown.Menu>
            </Dropdown>
        </div>
    );
};

export default ReconcilationMoreFilter;